import React, { useState, useRef, useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import { isVideo } from '../helpers';


import CarouselVideo from './CarouselVideo';

import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'

import { Gallery, Item } from 'react-photoswipe-gallery'
const CarouselComponent = ({ onClick, images = [], user, isFullScreen }) => {
  const handleItemClick = index => {
    if (onClick) onClick(index);
  };
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const carouselItemRef = useRef();
  const [width, setWidth] = useState(null);

  useEffect(() => {
    const sliderWidth = carouselItemRef?.current?.element?.clientWidth;
    setWidth(sliderWidth);
  }, [width]);

  const controls = images.length > 1 ? true : false;

  

  return (
    <>
      <Gallery  >
        <Carousel
          indicators={controls}
          ref={carouselItemRef}
          controls={controls}
          interval={null}
          activeIndex={index}
          onSelect={handleSelect}
        >

          {images.map((image, ind) => {
            return (





              <Carousel.Item key={`carousel${ind}`}>

                {isVideo(image.orig_src) ? (

                  <CarouselVideo src={image.orig_src} index={ind} ext={image.thumb_src ? image.thumb_src : image.orig_src} activeIndex={index} />
                ) : (

                  <>
                    <div
                      className={`post-img-cont-wrapper ` + (images.length === 1 ? 'single-image' : 'multiple-images')}

                    >
                      <Item
                        original={image.orig_src}
                        thumbnail={image.thumb_src}
                        width="1024"
                        height="0"
                      >
                        {({ ref, open }) => (


                          <>
                            <img
                              ref={ref} onClick={open}
                              className='post-img-cont pointer-cursor'


                              alt=".." src={image.thumb_src} srcSet={image.srcset ? image.srcset : image.orig_src} />

                          </>

                        )}
                      </Item>
                    </div>
                  </>
                )}

              </Carousel.Item>







            )
          })}


        </Carousel>


      </Gallery>


    </>
  );
};

export default CarouselComponent;